import React from "react";
import PropTypes from "prop-types";
import FaArrowDown from "react-icons/lib/fa/arrow-down";

import { isSpotifyAccessTokenValid, authSpotify, logoutOfSpotifyAndRedirectToHome } from '../../lib/spotify-auth';
import { getMe } from '../../lib/spotify-api';
import { setNewLocation } from '../../lib/window';

class Hero extends React.Component {
  constructor() {
    super();

    this.state = {
      logged_in_spotify: isSpotifyAccessTokenValid(),
      spotifyProfile: null
    };
  }

  componentDidMount() {
    if (isSpotifyAccessTokenValid()) {
      getMe().then((response) => {
        this.setState({ spotifyProfile: response, logged_in_spotify: true });
      });
    }
  }

  render() {
    const { scrollToContent, backgrounds, theme } = this.props;
    const { logged_in_spotify, spotifyProfile } = this.state;
    const spotifyDisplayName = spotifyProfile ? spotifyProfile.display_name : '';
    const showContinue = logged_in_spotify && spotifyDisplayName;

    return (
      <React.Fragment>
        <section className="hero">
          <h1>
            Convert your Spotify Playlists to YouTube.
          </h1>
          {showContinue &&
            <div>
              <button className="spotify-login" onClick={ () => setNewLocation('/converter') }>
                Continue as Spotify User - {spotifyDisplayName}
              </button>
              <br />
              <button className="spotify-login" onClick={ () => logoutOfSpotifyAndRedirectToHome() }>
                Logout
              </button>
            </div>

          }
          {!showContinue &&
            <button className="spotify-login" onClick={ () => authSpotify(false) }>
              Login to Spotify
            </button>
          }
          <button className="scroll-to-content" onClick={scrollToContent} aria-label="scroll">
            <FaArrowDown/>
            <span className="scroll-to-content-text">
            Check out our music video blog!
          </span>
            <FaArrowDown/>
          </button>
        </section>

        {/* --- STYLES --- */}
        <style jsx>{`
        .hero {
          align-items: center;
          background: ${theme.hero.background};
          background-image: url(${backgrounds.mobile});
          background-size: cover;
          color: ${theme.text.color.primary.inverse};
          display: flex;
          flex-flow: column nowrap;
          justify-content: center;
          min-height: 650px;
          height: 100vh;
          padding: ${theme.space.inset.l};
          padding-top: ${theme.header.height.homepage};
        }

        h1 {
          text-align: center;
          font-size: ${`calc(${theme.hero.h1.size} * .8)`};
          margin: ${theme.space.stack.l};
          color: ${theme.hero.h1.color};
          line-height: ${theme.hero.h1.lineHeight};
          text-remove-gap: both 0 "Open Sans";

          :global(strong) {
            position: relative;

            &::after,
            &::before {
              content: "›";
              color: ${theme.text.color.attention};
              margin: 0 ${theme.space.xs} 0 0;
              text-shadow: 0 0 ${theme.space.s} ${theme.color.neutral.gray.k};
            }
            &::after {
              content: "‹";
              margin: 0 0 0 ${theme.space.xs};
            }
          }
        }

        button.spotify-login {
          background: ${theme.color.spotify_green};
          color: white;
          border-radius: 50px;
          width: 500px;
          max-width: 100vw;
          min-height: 60px;
          margin-bottom: 20px;
        }

        button.scroll-to-content {
          background: black;
          color: white;
          border-radius: 50px;
          font-size: 1em;
          margin-top: 20px;
          max-width: 500px;
          min-height: 50px;
          width: 100vw;

          .scroll-to-content-text {
            color: white;
            margin: 0 15px;
          }
        }

        button {
          background: ${theme.background.color.brand};
          border: 0;
          font-size: ${theme.font.size.m};
          padding: ${theme.space.s} ${theme.space.m};
          cursor: pointer;

          &:focus {
            outline-style: none;
            background: ${theme.color.brand.primary.active};
          }

          :global(svg) {
            fill: ${theme.color.neutral.white};
            animation-duration: ${theme.time.duration.long};
            animation-name: buttonIconMove;
            animation-iteration-count: infinite;
          }
        }

        @keyframes buttonIconMove {
          0% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
          100% {
            transform: translateY(0);
          }
        }

        @from-width tablet {
          .hero {
            background-image: url(${backgrounds.tablet});
          }

          h1 {
            max-width: 90%;
            font-size: ${`calc(${theme.hero.h1.size} * 1.1)`};
          }

          button {
            font-size: ${theme.font.size.l};
          }

          button.scroll-to-content {
            width: 400px;
            margin-top: 100px;
          }
        }

        @from-width desktop {
          .hero {
            background-image: url(${backgrounds.desktop});
          }

          h1 {
            max-width: 80%;
            font-size: ${`calc(${theme.hero.h1.size} * 1.5)`};
          }

          button {
            font-size: ${theme.font.size.xl};
          }
        }
      `}</style>
      </React.Fragment>
    );
  }
};

Hero.propTypes = {
  scrollToContent: PropTypes.func.isRequired,
  backgrounds: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero/Hero.js